import { call, put, take } from 'redux-saga/effects'
import { networkErrors } from '../helpers/consts'
import api from '../api/api'
import {
  convertErrorsToString,
  isResponseSuccessful,
  statusCodeIsBelow400,
} from '../helpers/utility'

import {
  EMAIL_CHANGE_REQUEST,
  EMAIL_CHANGE_SUCCESS,
  EMAIL_CHANGE_FAIL,
  PASSWORD_CHANGE_REQUEST,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAIL,
  PROFILE_ASYNC_CALL_START,
  PROFILE_ASYNC_CALL_END,
  PROFILE_MINOR_ASYNC_CALL_START,
  PROFILE_MINOR_ASYNC_CALL_END,
  PROFILE_UPDATE_REQUEST,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_FAIL,
  FETCH_USER_PROFILE,
  FETCH_USER_PROFILE_SUCCESS,
  FETCH_USER_PROFILE_FAIL,
  MANAGER_REMOVE_USER_REQUEST,
  MANAGER_REMOVE_USER_FAIL,
  MANAGER_REMOVE_USER_ASYNC_START,
  MANAGER_REMOVE_USER_ASYNC_END,
  FETCH_CITIES_REQUEST,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAIL,
  FETCH_CITIES_ASYNC_START,
  FETCH_CITIES_ASYNC_END,
  FETCH_STATES_REQUEST,
  FETCH_STATES_SUCCESS,
  FETCH_STATES_FAIL,
  FETCH_STATES_ASYNC_START,
  FETCH_STATES_ASYNC_END,
  SEND_EMAIL_CONFIRMATION_LINK_ASYNC_END,
  SEND_EMAIL_CONFIRMATION_LINK_ASYNC_START,
  SEND_EMAIL_CONFIRMATION_LINK_REQUEST,
  SEND_EMAIL_CONFIRMATION_LINK_FAIL,
  SEND_EMAIL_CONFIRMATION_LINK_SUCCESS,
  SEND_SMS_CONFIRMATION_CODE_ASYNC_END,
  SEND_SMS_CONFIRMATION_CODE_ASYNC_START,
  SEND_SMS_CONFIRMATION_CODE_REQUEST,
  SEND_SMS_CONFIRMATION_CODE_FAIL,
  SEND_SMS_CONFIRMATION_CODE_SUCCESS,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAIL,
  VERIFY_PHONE_REQUEST,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_FAIL,
  FETCH_DISTRICTS_REQUEST,
  FETCH_DISTRICTS_SUCCESS,
  FETCH_DISTRICTS_FAIL,
  // FETCH_DISTRICTS_ASYNC_START,
  // FETCH_DISTRICTS_ASYNC_END,
  FETCH_CONTACTS_INFO,
  FETCH_CONTACTS_ASYNC_START,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACT_FAIL,
  FETCH_CONTACT_ASYNC_END,
} from '../actions/actions'

import {
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST,
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS,
  FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE,

  UPLOAD_USER_PROFILE_DOCUMENT_REQUEST,
  UPLOAD_USER_PROFILE_DOCUMENT_SUCCESS,
  UPLOAD_USER_PROFILE_DOCUMENT_FAILURE,

  UPDATE_USER_PROFILE_DOCUMENT_REQUEST,
  UPDATE_USER_PROFILE_DOCUMENT_SUCCESS,
  UPDATE_USER_PROFILE_DOCUMENT_FAILURE,

  REMOVE_USER_PROFILE_DOCUMENT_REQUEST,
  REMOVE_USER_PROFILE_DOCUMENT_SUCCESS,
  REMOVE_USER_PROFILE_DOCUMENT_FAILURE,
} from '../actions/actions'

export function* fetchProfileInfo() {
  while (true) {
    const { userId, userType, resolve } = yield take(FETCH_USER_PROFILE)
    if (userType !== 'MANAGER') {
      // managers do not have a profile
      // note that here userType is not coming from store,
      // it is passes manually, so it can be any userType
      yield put({ type: PROFILE_ASYNC_CALL_START })

      try {
        const {
          data: {
            data,
            status,
            errors: { general_errors },
          },
        } = yield call(api.fetchUserProfile, userId, userType)

        if (statusCodeIsBelow400(status)) {
          yield put({
            type: FETCH_USER_PROFILE_SUCCESS,
            userInfo: data[userType.toLowerCase()],
          })

          resolve && resolve()
        } else {
          yield put({ type: FETCH_USER_PROFILE_FAIL, general_errors })
        }

        yield put({ type: PROFILE_ASYNC_CALL_END })
      } catch (error) {
        yield put({ type: PROFILE_ASYNC_CALL_END })
        yield put({ type: FETCH_USER_PROFILE_FAIL, error })
      }
    }
  }
}

export function* profileUpdate() {
  // this is a partial update
  while (true) {
    const { formData, reject, resolve, userId, userType } = yield take(
      PROFILE_UPDATE_REQUEST
    )

    yield put({ type: PROFILE_ASYNC_CALL_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.updateProfile, formData, userId, userType)

      if (statusCodeIsBelow400(status)) {
        resolve && resolve(data)

        yield put({
          type: PROFILE_UPDATE_SUCCESS,
          userInfo: data[userType.toLowerCase()],
        })
      } else {
        reject && reject({ form_errors, general_errors })

        yield put({
          type: PROFILE_UPDATE_FAIL,
          errors: { form_errors, general_errors },
        })
      }

      yield put({ type: PROFILE_ASYNC_CALL_END })
    } catch (error) {
      reject({ general_errors: networkErrors.noConnection })
      yield put({ type: PROFILE_ASYNC_CALL_END })
      yield put({ type: PROFILE_UPDATE_FAIL, error })
    }
  }
}

export function* changeEmail() {
  // this is a partial update
  while (true) {
    const { formData, reject, resolve } = yield take(EMAIL_CHANGE_REQUEST)
    yield put({ type: PROFILE_MINOR_ASYNC_CALL_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.changeEmail, formData)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({ type: EMAIL_CHANGE_SUCCESS, newEmail: data.user.email })
        resolve({ data })
      } else {
        yield put({ type: EMAIL_CHANGE_FAIL })
        reject({ form_errors, general_errors })
      }

      yield put({ type: PROFILE_MINOR_ASYNC_CALL_END })
    } catch (error) {
      reject({ general_errors: networkErrors.noConnection })
      yield put({ type: PROFILE_MINOR_ASYNC_CALL_END })
      yield put({ type: EMAIL_CHANGE_FAIL, error })
    }
  }
}

export function* changePassword() {
  // this is a partial update
  while (true) {
    const { formData, reject, resolve } = yield take(PASSWORD_CHANGE_REQUEST)
    yield put({ type: PROFILE_MINOR_ASYNC_CALL_START })

    try {
      const {
        data: {
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.changePassword, formData)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({ type: PASSWORD_CHANGE_SUCCESS })
        resolve(true)
      } else {
        yield put({ type: PASSWORD_CHANGE_FAIL })
        reject({
          form_errors: convertErrorsToString(form_errors),
          general_errors: general_errors,
        })
      }

      yield put({ type: PROFILE_MINOR_ASYNC_CALL_END })
    } catch (error) {
      reject({ general_errors: networkErrors.noConnection })
      yield put({ type: PROFILE_MINOR_ASYNC_CALL_END })
      yield put({ type: PASSWORD_CHANGE_FAIL, error })
    }
  }
}

export function* removeUser() {
  // only for manager
  while (true) {
    const { userType, userId } = yield take(MANAGER_REMOVE_USER_REQUEST)
    yield put({ type: MANAGER_REMOVE_USER_ASYNC_START })

    try {
      const {
        data: {
          status,
          errors: { form_errors, general_errors },
        },
      } = yield call(api.removeUserFromSystem, userType, userId)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: `MANAGER_REMOVE_${userType.toUpperCase()}_SUCCESS`,
          userId,
        })
      } else {
        yield put({ type: MANAGER_REMOVE_USER_FAIL })
      }

      yield put({ type: PROFILE_MINOR_ASYNC_CALL_END })
    } catch (error) {
      yield put({ type: MANAGER_REMOVE_USER_ASYNC_END })
      yield put({ type: MANAGER_REMOVE_USER_FAIL, error })
    }
  }
}

export function* fetchContactsInfo() {
  while (true) {
    yield take(FETCH_CONTACTS_INFO)
    yield put({ type: FETCH_CONTACTS_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchContactsInfo)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_CONTACTS_SUCCESS,
          contacts: data.contacts,
        })
      } else {
        yield put({ type: FETCH_CONTACT_FAIL, general_errors })
      }

      yield put({ type: FETCH_CONTACT_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_CONTACT_ASYNC_END })
      yield put({ type: FETCH_CONTACT_FAIL, error })
    }
  }
}

export function* fetchCities() {
  while (true) {
    const { stateId } = yield take(FETCH_CITIES_REQUEST)
    yield put({ type: FETCH_CITIES_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchCities, stateId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_CITIES_SUCCESS,
          cities: data.citys,
        })
      } else {
        yield put({ type: FETCH_CITIES_FAIL, general_errors })
      }

      yield put({ type: FETCH_CITIES_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_CITIES_ASYNC_END })
      yield put({ type: FETCH_CITIES_FAIL, error })
    }
  }
}

export function* fetchStates() {
  while (true) {
    yield take(FETCH_STATES_REQUEST)
    yield put({ type: FETCH_STATES_ASYNC_START })

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchStates)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_STATES_SUCCESS,
          states: data.states,
        })
      } else {
        yield put({ type: FETCH_STATES_FAIL, general_errors })
      }

      yield put({ type: FETCH_STATES_ASYNC_END })
    } catch (error) {
      yield put({ type: FETCH_STATES_ASYNC_END })
      yield put({ type: FETCH_STATES_FAIL, error })
    }
  }
}

export function* fetchDistricts() {
  while (true) {
    const { resolve, reject, stateId } = yield take(FETCH_DISTRICTS_REQUEST)
    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors },
        },
      } = yield call(api.fetchDistricts, stateId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: FETCH_DISTRICTS_SUCCESS,
          districts: data.districts,
        })
        resolve && resolve(data.districts)
      } else {
        yield put({ type: FETCH_DISTRICTS_FAIL, general_errors })
        reject && reject(general_errors)
      }
    } catch (error) {
      yield put({ type: FETCH_DISTRICTS_FAIL, error })

      reject && reject(error)
    }
  }
}

export function* sendEmailVerification() {
  while (true) {
    const { resolve, reject } = yield take(SEND_EMAIL_CONFIRMATION_LINK_REQUEST)
    yield put({ type: SEND_EMAIL_CONFIRMATION_LINK_ASYNC_START })

    try {
      const {
        data: { status, errors },
      } = yield call(api.sendConfirmationEmail)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SEND_EMAIL_CONFIRMATION_LINK_SUCCESS,
        })

        resolve()
      } else {
        yield put({ type: SEND_EMAIL_CONFIRMATION_LINK_FAIL })
        reject(errors)
      }

      yield put({ type: SEND_EMAIL_CONFIRMATION_LINK_ASYNC_END })
    } catch (error) {
      yield put({ type: SEND_EMAIL_CONFIRMATION_LINK_ASYNC_END })
      yield put({ type: SEND_EMAIL_CONFIRMATION_LINK_FAIL, error })
    }
  }
}

export function* verifyEmail() {
  while (true) {
    const { formData, auth } = yield take(VERIFY_EMAIL_REQUEST)

    try {
      const {
        data: { status },
      } = yield call(api.verifyEmail, formData, auth)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: VERIFY_EMAIL_SUCCESS,
        })
      } else {
        yield put({ type: VERIFY_EMAIL_FAIL })
      }
    } catch (error) {
      yield put({ type: VERIFY_EMAIL_FAIL, error })
    }
  }
}

export function* sendSmsVerification() {
  while (true) {
    const { resolve, reject } = yield take(SEND_SMS_CONFIRMATION_CODE_REQUEST)
    yield put({ type: SEND_SMS_CONFIRMATION_CODE_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.sendConfirmationSms)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: SEND_SMS_CONFIRMATION_CODE_SUCCESS,
        })

        resolve(data)
      } else {
        yield put({ type: SEND_SMS_CONFIRMATION_CODE_FAIL, errors })
        reject(errors)
      }

      yield put({ type: SEND_SMS_CONFIRMATION_CODE_ASYNC_END })
    } catch (error) {
      yield put({ type: SEND_SMS_CONFIRMATION_CODE_ASYNC_END })
      yield put({ type: SEND_SMS_CONFIRMATION_CODE_FAIL, error })
    }
  }
}

export function* verifyPhone() {
  while (true) {
    const { formData, resolve, reject } = yield take(VERIFY_PHONE_REQUEST)

    try {
      const {
        data: { status, errors },
      } = yield call(api.verifyPhone, formData)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: VERIFY_PHONE_SUCCESS,
        })
        resolve()
      } else {
        yield put({ type: VERIFY_PHONE_FAIL })
        reject(errors)
      }
    } catch (error) {
      yield put({ type: VERIFY_PHONE_FAIL, error })
    }
  }
}


export function* fetchProfileDocumentsGroup() {
  while (true) {
    const {
      formData,
      resolve,
      reject
    } = yield take(FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST)

      try {
        const {
          data: {
            data,
            status,
            errors: { general_errors, form_errors },
          },
        } = yield call(api.fetchUserProfileDocumentsGroup, formData)

        if (statusCodeIsBelow400(status)) {
          yield put({
            type: FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS,
            groups: data.groups,
          })

          resolve && resolve(data)
        } else {
          yield put({
            type: FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE,
            error: { general_errors, form_errors },
          })
          reject && reject({ general_errors, form_errors })
        }

      } catch (error) {
        yield put({
          type: FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE,
          error,
        })

        reject && reject(error)
      }
  }
}

export function* uploadUserProfileDocument() {
  while (true) {
    const {
      formData,
      resolve,
      reject
    } = yield take(UPLOAD_USER_PROFILE_DOCUMENT_REQUEST)

      try {
        const {
          data: {
            data,
            status,
            errors: { general_errors, form_errors },
          },
        } = yield call(api.uploadDocumentToProfile, formData)

        if (statusCodeIsBelow400(status)) {
          yield put({
            type: UPLOAD_USER_PROFILE_DOCUMENT_SUCCESS,
            data,
          })

          resolve && resolve(data)
        } else {
          yield put({
            type: UPLOAD_USER_PROFILE_DOCUMENT_FAILURE,
            error: { general_errors, form_errors },
          })
          reject && reject({ general_errors, form_errors })
        }

      } catch (error) {
        yield put({
          type: UPLOAD_USER_PROFILE_DOCUMENT_FAILURE,
          error,
        })

        reject && reject(error)
      }
  }

}

export function* removeUserProfileDocument() {
  while (true) {
    const {
      documentId,
      resolve,
      reject
    } = yield take(REMOVE_USER_PROFILE_DOCUMENT_REQUEST)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.removeDocumentFromProfile, documentId)

      if (statusCodeIsBelow400(status)) {
        yield put({
          type: REMOVE_USER_PROFILE_DOCUMENT_SUCCESS,
          data,
        })

        resolve && resolve(data)
      } else {
        yield put({
          type: REMOVE_USER_PROFILE_DOCUMENT_FAILURE,
          error: { general_errors, form_errors },
        })
        reject && reject({ general_errors, form_errors })
      }

    } catch (error) {
      yield put({
        type: REMOVE_USER_PROFILE_DOCUMENT_FAILURE,
        error,
      })

      reject && reject(error)
    }
  }

}



// WEBPACK FOOTER //
// ./src/sagas/profileSaga.js